app.directive('regulationClassements', [
    '$rootScope', '$timeout', '$injector', 'utilsService', 'semanticUIService',
    function ($rootScope, $timeout, $injector, utilsService, semanticUIService) {
        return {
            restrict: 'AE',
            scope: {selectedClassements: '=', selectedSousClassements: '='},
            templateUrl: '/templates/partials/directives/regulation-classements.html',
            link: function (scope) {
                scope.loading = true;
                scope.classements = [];
                scope.checked_classements = {};
                scope.checked_sous_classements = {};
                scope.checkboxes = null;

                scope.addElement = function (id, label) {
                    if (!utilsService.isSet(id) || isNaN(id) || utilsService.isSet(scope.checked[id])) {
                        return;
                    }
                    scope.checked[id] = label;
                };
                scope.removeElement = function (id) {
                    if (!utilsService.isSet(id) || isNaN(id) || !utilsService.isSet(scope.checked[id])) {
                        return;
                    }
                    delete scope.checked[id];
                };

                scope.onChecked = function () {
                    let $el = $(this);
                    let value = parseInt($el.val(), 10);
                    let label = $el.data('label');

                    if ($el.attr('name') === 'select_all_sous_classements') {
                        scope._toggleAllChecked($el, 'check');
                    } else {
                        if ($el.attr('name') === 'classement') {
                            scope.checked_classements[value] = label;
                        } else {
                            scope.checked_sous_classements[value] = label;
                        }
                        $rootScope.$broadcast('regulation.classements.change', {
                            sous_classements: scope.checked_sous_classements,
                            classements: scope.checked_classements
                        });
                    }
                };

                scope.onUnchecked = function () {
                    let $el = $(this);
                    let value = parseInt($el.val(), 10);

                    if ($el.attr('name') === 'select_all_sous_classements') {
                        scope._toggleAllChecked($el, 'uncheck');
                    } else {
                        if ($el.attr('name') === 'classement') {
                            delete scope.checked_classements[value];
                        } else {
                            delete scope.checked_sous_classements[value];
                        }
                        $rootScope.$broadcast('regulation.classements.change', {
                            sous_classements: scope.checked_sous_classements,
                            classements: scope.checked_classements
                        });
                    }
                };

                scope.setSelectedClassements = function (id) {
                    let $checkbox = scope.checkboxes.find('[name="classement"][value="' + id + '"]');
                    if (!$checkbox || !$checkbox.length) {
                        return;
                    }
                    $checkbox.parent('.ui.checkbox').checkbox('check');
                };

                scope.setSelectedSousClassements = function (id) {
                    let $checkbox = scope.checkboxes.find('[name="sous_classements[]"][value="' + id + '"]');
                    if (!$checkbox || !$checkbox.length) {
                        return;
                    }
                    $checkbox.parent('.ui.checkbox').checkbox('check');
                };

                scope._toggleAllChecked = function ($el, state) {
                    let classement_id = $el.data('classement-id');
                    let $checkboxes = Array.from(document.querySelectorAll(`[name="sous_classements[]"][data-classement-id="${classement_id}"]`));
                    if (!$checkboxes || !$checkboxes.length) {
                        return;
                    }
                    $checkboxes.forEach(item => $(item).parent().checkbox(state));
                };

                $rootScope.$on('regulations.classements.reset', function () {
                    scope.checked_classements = {};
                    scope.checked_sous_classements = {};
                    scope.checkboxes.checkbox('set unchecked');
                });

                let API = $injector.has('RegulationApiService')
                    ? $injector.get('RegulationApiService')
                    : $injector.get('ClassementClientApiService');

                API
                    .getClassements()
                    .then(function (response) {
                        if (response) {
                            scope.classements = response;
                            $timeout(function () {
                                scope.checkboxes = semanticUIService.load("checkbox", ".ui.checkbox", {
                                    onChecked: scope.onChecked,
                                    onUnchecked: scope.onUnchecked
                                });

                                semanticUIService.load("accordion", undefined, {
                                    selector: {trigger: '.trigger__icon'},
                                    exclusive: false,
                                    onOpening: function () {
                                        let $el = $(this).prev('.title').find('.trigger__icon > .icon');
                                        $el.removeClass('right');
                                        $el.addClass('down');
                                    },
                                    onClosing: function () {
                                        let $el = $(this).prev('.title').find('.trigger__icon > .icon');
                                        $el.removeClass('down');
                                        $el.addClass('right');
                                    }
                                });

                                if (scope.selectedClassements && scope.selectedClassements.length) {
                                    scope.selectedClassements.split(',').forEach(scope.setSelectedClassements);
                                }

                                if (scope.selectedSousClassements && scope.selectedSousClassements.length) {
                                    scope.selectedSousClassements.split(',').forEach(scope.setSelectedSousClassements);
                                }
                            });
                        }

                        scope.loading = false;
                    });
            }
        }
    }]);
